<template>
  <section class="skin-similar">
    <h2 class="mb24">{{ t(title) }}</h2>
    <div class="skin-similar_wrap g250 gap32">
      <div v-for="(item, i) of currItems" :key="i" class="item card-dark p16">
        <div class="item-name ell">{{ item.localed_name }}</div>
        <NuxtLink :to="getItemLinkWithoutExt({
          name: item.market_hash_name,
          slug: item.link
        })">
          <Thumb
              :fontSize="18"
              :image-height="150"
              :image-width="200"
              :item="item"
              :size="18"
              :src="getImageFromWaxpeer(item.market_hash_name)"
              loading="lazy"
          />
        </NuxtLink>
        <div class="item-price f">
          <span class="gray">{{ $t('Starting at') }}</span>
          <UiPrice :price="item.price" />
        </div>
        <div class="item-footer">
          <NuxtLink :to="getItemLinkWithoutExt({
            name: item.market_hash_name,
            slug: item.link
          })"
                    class="btn btn-gradient h44">
            {{ t('View') }}
          </NuxtLink>
        </div>
      </div>
    </div>
    <!--    <client-only>-->
    <PaginateV2
        v-if="items?.length > perPage"
        v-model="page"
        :pagesLength="Math.ceil(items?.length / perPage) "
    />
    <!--    </client-only>-->
  </section>
</template>

<script lang="ts" setup>
import Thumb from './Children/Thumb.vue'
import {useI18n} from 'vue-i18n'
import {ref} from 'vue'
import {useRuntimeConfig} from "nuxt/app";
import {useResize} from "~/composables/resize";
import type {FamilySimilarSkins} from "~/graphql/generated/schema-types";
import {getImageFromWaxpeer} from "~/utils/get-image-url";
import {getItemLinkWithoutExt} from "~/utils/name-utils";

const currW = useResize()
const {t, locale} = useI18n()
const config = useRuntimeConfig()
const siteHost = config.public.siteHost

const props = defineProps<{
  title: 'family_skins' | 'similar_skins',
  items: FamilySimilarSkins[]
}>()

const page = ref(1)
const perPage = ref(6)
const currItems = computed(() => {
  const from = page.value * perPage.value - perPage.value
  const to = page.value * perPage.value
  return props.items.slice(from, to)
})

</script>

<style lang="scss" scoped>

@use "sass:color";

.skin-similar {
  .item {
    transition: 0.3s;
    position: relative;
    top: 0;

    &:deep(.thumb) {
      img {
        max-height: 165px;
      }
    }

    &:hover {
      background: color-mix(in srgb, var(--surfaces-low-container) 96%, white);
      // transform: translateY(-3px);
      transform: scale(1.02);

      .thumb_bg {
        // transform: scale(1.1);
      }
    }

    &-type {
      color: var(--gray);
      font-size: 1.5rem;
      font-weight: 600;
      margin-bottom: 0.4rem;
    }

    &-name {
      font-size: 1.8rem;
      font-weight: 800;
      margin-bottom: 0.4rem;
    }

    &-price {
      margin-top: 1.6rem;

      p {
        font-weight: 800;
        font-size: 1.6rem;
        color: var(--surfaces-on-surface);
      }
    }

    &-footer {
      margin-top: 1.6rem;
      text-transform: capitalize;
    }
  }
}

@media screen and (max-width: 600px) {
  .skin-similar {
    overflow: hidden;
    margin: 3.2rem -1.6rem !important;

    h2 {
      margin-left: 1.6rem;
      margin-right: 1.6rem;
    }

    &_wrap {
      display: flex;
      gap: 1.6rem;
      overflow-x: auto;
      padding: 0 1.6rem 10px;
    }

    .item {
      min-width: 75vw;
    }
  }
}
</style>
